export const BREAKPOINTS = {
  small: '320px',
  mobile: '767px',
  medium: '768px',
  tabletAbove: '1200px',
  tablet: '1199px',
  large: '1366px',
  xlarge: '1920px',
}

export const ScreenSize = {
  small: `(max-width: ${BREAKPOINTS.small})`,
  mobile: `(max-width: ${BREAKPOINTS.mobile})`,
  medium: `(max-width: ${BREAKPOINTS.medium})`,
  tabletAbove: `(max-width: ${BREAKPOINTS.tabletAbove})`,
  tablet: `(max-width: ${BREAKPOINTS.tablet})`,
  large: `(max-width: ${BREAKPOINTS.large})`,
  xlarge: `(max-width: ${BREAKPOINTS.xlarge})`,
}
